import React, { useState } from 'react'
import { ModalBase } from '../../../components/modal/ModalBase'
import { patternsValidators } from '../../../model/enum'
import { isValidCPF } from '../../../util/validators'
import { Input, TokenInput } from '../../../components/ui/Input'
import { useGenericFormValidator } from '../../../util/genericFormValidator'
import { useRedux } from '../../../redux/hook/useRedux'
import { actionForgotPasswordUser } from '../../../redux/user/actions'
import { Alert } from '../../../util/Alert'

const ModalForgotPassword = ({
    show,
    setShow
}) => {
    const { dispatch } = useRedux();
    const initialForm = {
        email: '',
        cpf: ''
    }

    const personalDataFormRules = {
        email: {
            required: true,
            pattern: patternsValidators.email
        },
        cpf: {
            required: true,
            pattern: patternsValidators.cpf,
            custom: (value) => isValidCPF(value),
        }
    }

    const closeModal = () => {
        setShow(false);
        setForm(initialForm);
    }

    const { form, handleChange, validate, errors, setForm } = useGenericFormValidator(initialForm, personalDataFormRules)

    const onSendForm = () => {
        var isValid = validate();
        if (isValid) {
            dispatch(actionForgotPasswordUser(form, res => {
                Alert(res.message);
                closeModal();
            }))
        }
    }

    return (
        <ModalBase
            modalState={{
                identifier: '',
                isEdit: false,
                show: show
            }}
            title="Digite os dados abaixo para recuperar"
            buttonTitle='Enviar'
            funcNewItem={onSendForm}
            onClose={closeModal}
        >
            {<React.Fragment>
                <div className='w-full'>
                    <Input className="w-full" name='email' value={form.email} onChange={handleChange} type='text' label='E-mail' placeholder='seu@email.com' />
                    {errors["email"] && <p className="text-red-500 text-sm">{errors["email"]}</p>}
                </div>
                <div className='w-full'>
                    <Input maxLength={14} className="w-full" name='cpf' value={form.cpf} onChange={handleChange} type='text' label='CPF' placeholder='xxx.xxx.xxx-xx' />
                    {errors["cpf"] && <p className="text-red-500 text-sm">{errors["cpf"]}</p>}
                </div>
            </React.Fragment>}
        </ModalBase>
    )
}

export default ModalForgotPassword